import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import { useSeo } from "@/hooks/useSeo";
import { faqs, siteMeta } from "@/mocks/site";
import Hero from "./components/Hero";
import HotTicker from "./components/HotTicker";
import FeaturedRecaps from "./components/FeaturedRecaps";
import CategoryGrid from "./components/CategoryGrid";
import LatestList from "./components/LatestList";
import FaqSection from "./components/FaqSection";
import VoiceSection from "./components/VoiceSection";
import CtaBanner from "./components/CtaBanner";

export default function Home() {
  useSeo({
    title: "独家吃瓜 - 深扒内幕与真相复盘，理清来龙去脉",
    description:
      "独家吃瓜专注事件深扒与真相复盘：按时间线梳理独家吃瓜内幕、细节线索与各方声明，把一件事的来龙去脉讲清楚，帮你看懂事件背后的逻辑。",
    keywords: "独家吃瓜,独家吃瓜深扒,独家吃瓜内幕,独家吃瓜真相,独家吃瓜复盘",
    canonicalPath: "/",
    jsonLd: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebSite",
          name: siteMeta.name,
          url: "/",
          description: siteMeta.intro,
          potentialAction: {
            "@type": "SearchAction",
            target: "/archive?q={search_term_string}",
            "query-input": "required name=search_term_string",
          },
        },
        {
          "@type": "Organization",
          name: siteMeta.name,
          description: siteMeta.intro,
          email: siteMeta.email,
        },
        {
          "@type": "FAQPage",
          mainEntity: faqs.map((faq) => ({
            "@type": "Question",
            name: faq.question,
            acceptedAnswer: { "@type": "Answer", text: faq.answer },
          })),
        },
      ],
    },
  });

  return (
    <>
      <SiteHeader overlay />
      <main>
        <Hero />
        <HotTicker />
        <FeaturedRecaps />
        <CategoryGrid />
        <LatestList />
        <FaqSection />
        <VoiceSection />
        <CtaBanner />
      </main>
      <SiteFooter />
      <BackToTop />
    </>
  );
}